// extracted by mini-css-extract-plugin
module.exports = {"pintxo-tab":"Tab_pintxo-tab__v_IqG","pintxo-tab__content":"Tab_pintxo-tab__content__4bMnI","pintxo-tab__indicator":"Tab_pintxo-tab__indicator__nI4If"};